import Keys from "@/constant/key"
import dayjs from 'dayjs'
import { useStore } from '@/store/index'
const store = useStore()

// 日期时间相关 ----------------- begin
// 日期格式化
export const dateFormat = (val) => {
    if (!val) { return console.log('timeFormat 参数错误') }

    val = val.toString().replace(/-/g, '/')
    let dateObj = new Date(val)
    let y = dateObj.getFullYear()
    let m = dateObj.getMonth() + 1
    let d = dateObj.getDate()
    return `${y}-${m < 10 ? '0'+m : m}-${d < 10 ? '0'+d : d}`
}
// 获取当前日期
export const getCurrentDate = () => {
    const currentDate = new Date();
    const y = currentDate.getFullYear(); // 当天年份
    const m = currentDate.getMonth() + 1; // 当天月份，注意月份从 0 开始，所以要加 1
    const d = currentDate.getDate(); // 当天日期

    return `${y}-${m < 10 ? '0'+m : m}-${d < 10 ? '0'+d : d}`;
}
// 时间格式化
export const timeFormat = (val) => {
    if (!val) { return console.log('timeFormat 参数错误') }

    val = val.toString().replace(/-/g, '/')
    let timeObj = new Date(val)
    let date = dateFormat(val)
    let h = timeObj.getHours()
    let m = timeObj.getMinutes()
    let s = timeObj.getSeconds()

    return `${date} ${h < 10 ? '0'+h : h}:${m < 10 ? '0'+m : m}:${s < 10 ? '0'+s : s}`
}

/**
 * 根据某个时间获取指定天数后的相同时间
 * time：给定时间
 * val： 指定天数
 * */
export const getDelayTime = (time, val,type='time') => {
    if (!time || !val) {
        return console.log('getDelayTime 参数错误')
    }
    let date = new Date(time.replace(/-/g, '/'))
    date.setDate(date.getDate() + val) // 获取 val 天后的日期
    let Y = date.getFullYear(),
        M = date.getMonth() + 1,
        D = date.getDate(),
        h  = date.getHours(),
        m = date.getMinutes(),
        s = date.getSeconds();
    let result = Y + '-' + (M<10?'0'+M:M) + '-' + (D<10?'0'+D:D)
    if(type === 'time'){
        result+=' ' + (h<10?'0'+h:h) + ':' + (m<10?'0'+m:m) + ':' + (s<10?'0'+s:s)
    }
    return result
}

/**
 * 根据毫秒数返回 xx天xx时xx分xx秒 格式
*/
export const millisecondFormat = (val:number) => {
    const totalSecond = Math.floor(val / 1000)
    const s = Math.abs(totalSecond) % 60
    const m = Math.abs(Math.floor(totalSecond / 60)) % 60
    const h = Math.abs(Math.floor(Math.floor(totalSecond / 60) / 60)) % 24
    const d = Math.floor(totalSecond / 60 / 60 / 24)

    return `${d ? d + '天' : ''}${h || d ? h + '小时' : ''}${m + '分'}${s + '秒'}`
}

//判断某个时间是否在某个时间段内
export const isWithinRange = (date, start, end) => {
    return date >= start && date <= end;
}

//判断是否为国庆前15天和国庆后7天
export const isNationalDayRange = (date) => {
    // 获取当前年份
    var currentYear = new Date().getFullYear();
    // 计算国庆节日期范围
    const nationalDayStart = new Date(currentYear, 8, 15).getTime()
    const nationalDayEnd = new Date(currentYear, 9, 7).getTime()
    return isWithinRange(date, nationalDayStart, nationalDayEnd);
}

// 获取指定日期为当前的第几周，如果未传值则获取当天
export const getWeekOfMonth = (str:any) => {
    const date = new Date(str || '')
    const dayOfMonth = date.getDate()
    const dayOfWeek = date.getDay()
    const weekOfMonth = Math.ceil((dayOfMonth + 6 - dayOfWeek) / 7)
    return weekOfMonth
}

// 获取上一周第一天和最后一天的日期
export const getFirstAndLastDayOfLastWeek = () => {
    const today = dayjs();
    const lastWeek = today.subtract(1, 'week');
    const firstDay = lastWeek.startOf('week').add(1, 'day').format('MM-DD');
    const lastDay = lastWeek.endOf('week').add(1, 'day').format('MM-DD');

    return {
        firstDay,
        lastDay
    }
}

// 获取昨天的日期
export const getYesterday = () => {
    const today = dayjs()
    const yesterday = today.subtract(1, 'day')
    const yesterdayDate = yesterday.format('YYYY-MM-DD')

    return yesterdayDate
}

// 获取上个月
export const getLastMonth = () => {
    const month = new Date().getMonth()
    const lastMonth = month == 0 ? 12 : month

    return lastMonth < 10 ? `0${lastMonth}` : lastMonth
}

// 获取上个月最后一天的日期
export const getLastDayOfLastMonth = () => {
    const today = dayjs()
    const lastMonth = today.subtract(1, 'month')
    const lastDayOfLastMonth = lastMonth.endOf('month').format('MM-DD')

    return lastDayOfLastMonth
}

// 获取上个月的今天日期，格式为 YYYY-MM-DD
export const getLastMonthToday = () => {
    return dayjs().subtract(1, 'month').format('YYYY-MM-DD')
}
// 日期时间相关 ----------------- end


// 货币格式化
export const currencyFormat = (val) => {
    val = (val + '').replace(/[^0-9+-Ee.]/g, '')
    let n = !isFinite(+val) ? '0' : val+''
    let arr = n.split('.')
    let re = /(-?\d+)(\d{3})/

    while (re.test(arr[0])) {
        arr[0] = arr[0].replace(re, '$1' + ',' + '$2')
    }
    if ((arr[1] || '').length < 2) {
        arr[1] = arr[1] || ''
        arr[1] += new Array(2-arr[1].length + 1).join('0')
    }

    return arr.join('.')
}

// 地址栏参数拼接
export const joinParams = (data) => {
    let params = ''
    for (let k in data) {
        params += (data[k] === '' || data[k] === undefined || data[k] === null) ? '' : `&${k}=${data[k]}`
    }
    return params.substring(1)
}

// 清除对象值为空的属性
export const clearObjInvalidEl = (obj) => {
    for (let key in obj) {
        if (obj[key]==='' || obj[key]==='undefined' || obj[key]===null) {
            delete obj[key]
        }
    }
    return obj
}

// 数组相关 ----------------- begin
/**
 * 获取两个数组之间的差异项
 *      getArrDiffItems([1, 2, 3, 4], [1, 2, 4])    // [2]
 *      getArrDiffItems([1, 3, 5], [1, 2, 4])       // [3, 5, 2, 4]
 * */ 
export const getArrDiffItems = (arr1:any[], arr2:any[]) => {
    // 将两个数组进行合并，并返回只出现过一次的项（即第一次出现的位置和最后一次出现的位置相同）
    return arr1.concat(arr2).filter((v, i, arr) => {
        return arr.indexOf(v) === arr.lastIndexOf(v)
    })
}
/**
 * 对象数组排序
 * arr：排序源数据
 * key：排序值
 * options：
 *      desc：是否倒序
 *      isNumber：是否转换为数值进行比较
 * */
export const arrSortByKey = (arr:object[], key:any, options:any = {}) => {
    arr.sort((a, b) => {
        let val1 = options.isNumber ? Number(a[key]) : a[key]
        let val2 = options.isNumber ? Number(b[key]) : b[key]
        if (options.desc) {
            if (val1 < val2) return 1
            if (val1 > val2) return -1
        } else {
            if (val1 < val2) return -1
            if (val1 > val2) return 1
        }
        return 0
    })
    return arr
}
// 数组相关 ----------------- end

/**
 * 获取字符串长度
 *      中文、中文标点、全角字符按 1 长度计算
 *      英文、英文符号、数字按 0.5 长度计算
 * */ 
export const getStrLength = (str) => {
    // 将两个数组进行合并，并返回只出现过一次的项（即第一次出现的位置和最后一次出现的位置相同）
    let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g
    let mat = str.match(cnReg)
    let length
    if (mat) {
        length = (mat.length + (str.length - mat.length) * 0.5)
        return length
    } else {
        return str.length * 0.5
    }
}

// 清除换行
export const clearBr = (str) => {
    str = str.replace(/<\/?.+?>/g,"")
    str = str.replace(/[\r\n]/g, "")
    return str
}

// 获取文件后缀名
export const getFileSuffix = (str) => {
    return (str.substr(str.lastIndexOf('.') + 1).toLowerCase()).split('?')[0]
}

// 生成随机颜色
export const getRandomColor = () => {
    let color = '#'
    for (let i = 0; i < 6; i++) {
        color += '0123456789abcdef'[Math.floor(Math.random() * 16)]
    }
    return color
}
//跳转链接
export const isHttpUrl = (url) => {
    const regex = /^https?:/i; // 允许 "http:" 或 "https:"，不区分大小写
    return regex.test(url);
}

// 获取URL的参数
export const getQueryByName = (url, name) => {
    var pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g")
    var matcher = pattern.exec(url)
    var item = ''
    if (matcher) {
        item = decodeURIComponent(matcher[1])
    }
    return item
}

// 获取图片高宽
export const getImgInfo = async (file) => {
    return await new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
            let img:any = new Image()
            img.src = reader.result
            img.onload = () => {
                const { width, height } = img
                
                resolve({
                    width,
                    height
                })
            }
        }
    })
}

// 手机号脱敏
export const maskPhone = (phone) => {
    return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}


// 导出文件
export const downloadFile = (filePath: string, params:object = {}) => {
    window.open(`${Keys.baseUrl}${filePath}?${joinParams({...params, user_id: store.state.user.userInfo.id, Access_token: store.state.user.userInfo.access_token })}`);
}